export default __webpack_public_path__ + "static/media/dwyer-omega.80637b2a.png";